import {
  SET_APP_LANGUAGE,
  SET_LOGIN_DETAILS,
  SET_SERVICE_LOADER,
  SET_USER_DETAILS,
  SET_ROLE_ACCESS_DETAILS,
  SET_COMPANY_DETAILS,
  SET_PROFILE_IMAGE_DETAILS,
  SET_MENU_DETAILS,
  SET_SUB_ROLE_ACCESS_DETAILS,
  SET_ROLE_ACCESS_KEY,
  SET_ACCOUNT_LIST,
  SET_ACCOUNT_REFRESH,
  SET_CURRENT_ACC_DETAILS,
  SET_OFFERS,
  SET_BILLERS_LIST,
  SET_FEATURE_LIST,
  SET_ACC_CLASS,
  SET_MENU_LIST
} from '../constants'

const initialState = {
  language: 'en',
  loginDetails: {},
  isServiceLoader: false,
  roleAccessDetails: {},
  companyDetails: {},
  menuDetails: [],
  userDetails: {},
  profileImageDetails: null,
  subRoleAccessDetails: {},
  roleAccessKey: 'I',
  accountList: [],
  selectedAccDetails: {},
  isAccRefresh: false,
  offerList: [],
  billersList: [],
  featureList: {},
  menuList: {},
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_APP_LANGUAGE:
      return { ...state, language: payload }
    case SET_LOGIN_DETAILS:
      return { ...state, loginDetails: payload }
    case SET_USER_DETAILS:
      return { ...state, userDetails: payload }
    case SET_ROLE_ACCESS_DETAILS:
      return { ...state, roleAccessDetails: payload }
    case SET_SUB_ROLE_ACCESS_DETAILS:
      return { ...state, subRoleAccessDetails: payload }
    case SET_COMPANY_DETAILS:
      return { ...state, companyDetails: payload }
    case SET_PROFILE_IMAGE_DETAILS:
      return { ...state, profileImageDetails: payload }
    case SET_ROLE_ACCESS_KEY:
      return { ...state, roleAccessKey: payload }
    case SET_MENU_DETAILS:
      return { ...state, menuDetails: payload }
    case SET_SERVICE_LOADER:
      return { ...state, isServiceLoader: payload }
    case SET_ACCOUNT_LIST:
      return { ...state, accountList: payload }
    case SET_CURRENT_ACC_DETAILS:
      return { ...state, selectedAccDetails: payload }
    case SET_ACCOUNT_REFRESH:
      return { ...state, isAccRefresh: payload }
    case SET_OFFERS:
      return { ...state, offerList: payload }
    case SET_BILLERS_LIST:
      return { ...state, billersList: payload }
    case SET_FEATURE_LIST:
      return { ...state, featureList: payload }
    case SET_ACC_CLASS:
      return { ...state, accClass: payload }
    case SET_MENU_LIST:
      return { ...state, menuList: payload }
    default:
      return state
  }
}
